import type {CodeList, CodeListId} from '../types';

// Cached, so repeated calls for the same id stay referentially stable, cf. useOptionalCodeLists
const dummyCache: {[id in CodeListId]?: CodeList} = {};

export const getDummyCodeList = (id: CodeListId): CodeList => {
  if (!dummyCache[id]) {
    dummyCache[id] = {
      id,
      language: 'nb',
      codes: [
        {
          code: 'code1',
          value: `${id}-1`,
        },
        {
          code: 'code1',
          value: `${id}-2`,
        },
        {
          code: 'code1',
          value: `${id}-3`,
        },
      ],
    };
  }

  return dummyCache[id];
};
